import { AccountInfo, IdTokenClaims } from "@azure/msal-browser";

export interface Claims {
  roles: string;
  permissions: string;
}

export enum UserRole {
  CLIENT_ADMIN = "clientadmin", 
  ADMIN = "admin"
}

export enum UserPermission {
  MANAGE_CONTENT = "managecontent"
}

export interface UserAccess {
  role: UserRole
  permissions: UserPermission[]
}

export function decodeJwt(claims: {[key: string]: unknown}): Claims | null {
  return {
    roles: claims["roles"] as string,
    permissions: claims["permissions"] as string
  };
}

export function getUserAccess(account: AccountInfo | null): UserAccess | null {
    if (!account || !account.idToken) {
      console.log(`Account is malformed or doesn't have token`)
      return null
    }

    if (account?.idTokenClaims == undefined) {
      console.log(`Account has no valid claims`)
      return null;
    }

    const claims = decodeJwt(account?.idTokenClaims);
    if (claims == null) {
      console.log(`couldn't decode jwt: ${account.idToken}`)
      return null
    }

    let roles = claims?.roles?.split(',').map((g: string) => g.trim());
    if (roles?.length == 0) {
        console.log(`no user roles found in payload: ${claims.roles}`)
        return null
    }

    let role =  extractUserRole(roles)

    let split = claims?.permissions?.split(',').map((g: string) => g.trim());
    let permissions = extractPermissions(split)

    return {
      role: role,
      permissions: permissions
    } as UserAccess
}

export const extractUserRole = (roles: string[]): UserRole | null => {
    let admin = roles?.some(g => g.trim().toLowerCase() === UserRole.ADMIN.toString());
    if (admin) {
      return UserRole.ADMIN
    }

    let clientAdmin = roles?.some(g => g.trim().toLowerCase() === UserRole.CLIENT_ADMIN.toString());
    if (clientAdmin) {
      return UserRole.CLIENT_ADMIN
    }

    return null
}


export const extractPermissions = (permissions: string[]): UserPermission[] | null => {
    let list: UserPermission[] = []

    for (let permission of permissions){
        let casted = <UserPermission>permission
        list.push(casted)
    }

    return list
}